import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Form, FormItemProps, Image, Select } from 'antd';
import { t } from 'i18next';

import { useGetImagesListQuery } from '../store/Api';


type Props = FormItemProps;

export const SelectImage = ({ ...formProps }: Props) => {
  const { data: images = { items: [] }, isLoading } = useGetImagesListQuery({ pageSize: 40, page: 1 });

  if (isLoading) {
    return (<LoadingOutlined />);
  }

  return (
    <Form.Item
      label={t('table.image')}
      name="imageId"
      {...formProps}
    >
      <Select
        showSearch
        optionFilterProp="children"
        filterSort={(optionA, optionB) =>
          (optionA?.searchText ?? '').toLowerCase().localeCompare((optionB?.searchText ?? '').toLowerCase())}
      >
        {images.items.map(({ id, url }) => (
          <Select.Option key={id} value={id}>
            <Image src={url ?? ''} height={30} />
            <span style={{ marginLeft: '6px' }}>{id}</span>
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
